<template>
  <div class = "loadingBox">
    <div class = "l_box">
      <!--<div class = "lb_pic lb_ani"></div>
      <p class = "lb_txt">{{txtLang[curLang]['loading']}}</p>-->
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  components:{},
  data () {
    return {
      
    }
  },
  methods: {
  	demo_fun () {

  	}
  },
  created(){
  	//控制台查看变量
    //window.vueVar = this;
  }
}
</script>

<style scoped>
@keyframes ani_rotate{
    0% {transform:rotate(0deg)}
    100% {transform:rotate(360deg)}
}
@-moz-keyframes ani_rotate{
    0% {-moz-transform:rotate(0deg)}
    100% {-moz-transform:rotate(360deg)}
}
@-webkit-keyframes ani_rotate{
    0% {-webkittransform:rotate(0deg)}
    100% {-webkittransform:rotate(360deg)}
}
@-o-keyframes ani_rotate{
    0% {-o-transform:rotate(0deg)}
    100% {-o-transform:rotate(360deg)}
}
@-ms-keyframes ani_rotate{
    0% {-ms-transform:rotate(0deg)}
    100% {-ms-transform:rotate(360deg)}
}


.loadingBox{position:fixed;top:0;left:0;right:0;bottom:0;z-index:1000;}
.loadingBox .l_box{position:fixed;background-color:rgba(0,0,0,0.8);border-radius:10px;width:100%;height:100%;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);}
.loadingBox .l_box .lb_pic{border-radius:200px;width:60px;height:60px;margin:0 auto;border:4px solid #ccc;border-right:4px solid #fff;margin-bottom:20px}
.loadingBox .l_box .lb_txt{color:#fff;font-size:32px;text-align:center;font-weight:bolder}
.loadingBox .l_box .lb_ani{
  animation: ani_rotate 1s linear infinite;
  -moz-animation: ani_rotate 1s linear infinite;
  -webkit-animation: ani_rotate 1s linear infinite;
  -o-animation: ani_rotate 1s linear infinite;
  -ms-animation: ani_rotate 1s linear infinite;
}


.loader {
  position: relative;
  width: 2.5em;
  height: 2.5em;
  transform: rotate(165deg);
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);
}
.loader:before, .loader:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 0.5em;
  height: 0.5em;
  border-radius: 0.25em;
  transform: translate(-50%, -50%);
}
.loader:before {
  animation: before 2s infinite;
}
.loader:after {
  animation: after 2s infinite;
}

@keyframes before {
  0% {
    width: 0.5em;
    box-shadow: 1em -0.5em rgba(103, 112, 230, 1), -1em 0.5em rgba(255, 131, 84, 1);
  }
  35% {
    width: 2.5em;
    box-shadow: 0 -0.5em rgba(103, 112, 230, 0.75), 0 0.5em rgba(255, 131, 84, 0.75);
  }
  70% {
    width: 0.5em;
    box-shadow: -1em -0.5em rgba(103, 112, 230, 0.75), 1em 0.5em rgba(255, 131, 84, 0.75);
  }
  100% {
    box-shadow: 1em -0.5em rgba(103, 112, 230, 0.75), -1em 0.5em rgba(255, 131, 84, 0.75);
  }
}
@keyframes after {
  0% {
    height: 0.5em;
    box-shadow: 0.5em 1em rgba(94, 212, 227, 1), -0.5em -1em rgba(212, 118, 226, 1);
  }
  35% {
    height: 2.5em;
    box-shadow: 0.5em 0 rgba(94, 212, 227, 0.75), -0.5em 0 rgba(212, 118, 226, 0.75);
  }
  70% {
    height: 0.5em;
    box-shadow: 0.5em -1em rgba(94, 212, 227, 0.75), -0.5em 1em rgba(212, 118, 226, 0.75);
  }
  100% {
    box-shadow: 0.5em 1em rgba(94, 212, 227, 0.75), -0.5em -1em rgba(212, 118, 226, 0.75);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Loading.vue